import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Share(): React.ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#share_icon)">
        <path d="M19.5635 5.99108L14.3725 0.600552C14.2032 0.424933 13.9437 0.369805 13.7177 0.460758C13.4909 0.552589 13.3424 0.772223 13.3424 1.01657V3.61211H13.1428C8.84953 3.61211 5.35645 7.10519 5.35645 11.3984V12.5963C5.35645 12.8742 5.5521 13.1058 5.82276 13.169C5.86678 13.1801 5.91065 13.1849 5.95452 13.1849C6.18058 13.1849 6.397 13.0523 6.50155 12.8439C7.62443 10.5974 9.88204 9.20224 12.3936 9.20224H13.3424V11.7976C13.3424 12.0421 13.4909 12.2618 13.7177 12.3527C13.9422 12.4445 14.2032 12.3887 14.3725 12.2129L19.5635 6.82239C19.7871 6.59003 19.7871 6.22432 19.5635 5.99108Z" />
        <path d="M17.335 19.5841H2.96024C1.63937 19.5841 0.564453 18.5094 0.564453 17.1884V6.0081C0.564453 4.68722 1.63937 3.6123 2.96024 3.6123H5.35603C5.79764 3.6123 6.15458 3.96925 6.15458 4.41085C6.15458 4.85246 5.79764 5.2094 5.35603 5.2094H2.96024C2.51937 5.2094 2.16155 5.56722 2.16155 6.0081V17.1884C2.16155 17.6292 2.51937 17.9871 2.96024 17.9871H17.335C17.7757 17.9871 18.1335 17.6292 18.1335 17.1884V10.7997C18.1335 10.3581 18.4905 10.001 18.9321 10.001C19.3738 10.001 19.7308 10.3581 19.7308 10.7997V17.1884C19.7308 18.5094 18.6559 19.5841 17.335 19.5841Z" />
      </g>
      <defs>
        <clipPath id="share_icon">
          <rect width="19.1665" height="19.1665" transform="translate(0.564453 0.41748)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
